import { render, staticRenderFns } from "./ConfirmMailArea.vue?vue&type=template&id=3203124a&"
import script from "./ConfirmMailArea.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMailArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports